<template>
  <div @load="loadImage">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ title }}
      </div>
    </div>
    <div class="gameplay_game_box_list gameplay_tap_box memory5 playbomb">
      <div class="gameplay_tap_container ">
        <div class="gameplay_tap_row" v-for="(row, rowIndex) in numOfRow" :key="row">
          <div class="img_box" v-for="(answer, index) in numOfCols" :key="index"
               @click="registerUserAnswer(rowIndex, index + 1)"
               :disabled="buttonPushed"
               :ref="index + 1"
               :style="!buttonPushed ? 'cursor:pointer' : 'pointer-events:none'">
            <img  :src="twoDimensionalTable[rowIndex][index]">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'MemoryBombs',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      data: 0,
      title: null,
      gameInfo: null,
      positionOfCircle1: null,
      positionOfCircle2: null,
      positionOfStar1: null,
      positionOfStar2: null,
      positionOfStar3: null,
      twoDimensionalTable: [],
      brDisplayIndexXTable: [],
      brDisplayIndexYTable: [],
      nextStep: [],
      matrixX1: [0, 1, 2, 3, 4, 5, 6, 7],
      matrixX2: [8, 9, 10, 11, 12, 13, 14, 15],
      matrixY1: [0, 1, 4, 5, 8, 9, 12, 13],
      matrixY2: [2, 3, 6, 7, 10, 11, 14, 15],
      oneQuarter: [0, 1, 4, 5],
      twoQuarter: [2, 3, 6, 7],
      threeQuarter: [8, 9, 12, 13],
      fourQuarter: [10, 11, 14, 15],
      numOfRow: 4,
      numOfCols: 4,
      buttonPushed: false,
    };
  },
  created() {
    this.gameInfo = this.miniGames[this.currentMiniGameRound];
    this.initGameData();
    this.title = this.getTranslations.home_game_memory_bombs_memorize_the_bombs;
    let index = 0;
    this.buttonPushed = true;
    const bombs = this.gameInfo.bombsEnumList.filter(bombsEnum => bombsEnum === 'BOMB');
    if (bombs.length === 2) {
      this.positionOfStar3 = this.positionOfStar2;
    }
    this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
    for (let i = 0; i < this.numOfRow; i += 1) {
      for (let j = 0; j < this.numOfCols; j += 1) {
        if (index === this.positionOfStar1 || index === this.positionOfStar2 || index === this.positionOfStar3) {
          this.twoDimensionalTable[i][j] = 'static/images/game_images/memory_05/star.svg';
        }
        index += 1;
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.hideStars();
      this.title = this.getTranslations.home_game_memory_bombs_connect_dots;
    }, this.gameInfo.timer);
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.initStarsAndCircle();
    },
    hideStars() {
      let index = 0;
      this.buttonPushed = false;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          if (index === this.positionOfCircle1 || index === this.positionOfCircle2) {
            this.twoDimensionalTable[i][j] = 'static/images/game_images/memory_05/cyrcle.svg';
          } else if (index === this.positionOfStar1 || index === this.positionOfStar2 || index === this.positionOfStar3) {
            this.twoDimensionalTable[i][j] = 'static/images/game_images/memory_04/star_red.svg';
          }
          index += 1;
        }
      }
    },
    showStars() {
      let index = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          if (index === this.positionOfStar1 || index === this.positionOfStar2 || index === this.positionOfStar3) {
            this.twoDimensionalTable[i][j] = 'static/images/game_images/memory_05/star.svg';
          }
          index += 1;
        }
      }
    },
    registerUserAnswer(rowIndex, colIndex) {
      if (this.nextStep.length === 0) {
        if (((rowIndex * 4) + (colIndex - 1)) === this.positionOfCircle1 || ((rowIndex * 4) + (colIndex - 1)) === this.positionOfCircle2) {
          this.$refs[colIndex][rowIndex].classList.add('selected');
          console.log((rowIndex * 4) + (colIndex - 1));
          this.brDisplayIndexXTable.push(colIndex);
          this.brDisplayIndexYTable.push(rowIndex);
          this.nextStep.push((rowIndex * 4) + ((colIndex - 1)));
        }
      } else if ((Math.abs(this.nextStep.slice(-1) - ((rowIndex * 4) + (colIndex - 1))) === 4 || ((Math.abs(this.nextStep.slice(-1) - ((rowIndex * 4) + (colIndex - 1))) === 1) && Math.abs(colIndex - this.brDisplayIndexXTable.slice(-1)) === 1)) && (!this.nextStep.includes(((rowIndex * 4) + (colIndex - 1))))) {
        this.$refs[colIndex][rowIndex].classList.add('selected');
        console.log((rowIndex * 4) + (colIndex - 1));
        this.nextStep.push((rowIndex * 4) + (colIndex - 1));
        this.brDisplayIndexXTable.push(colIndex);
        this.brDisplayIndexYTable.push(rowIndex);
        if ((((rowIndex * 4) + (colIndex - 1)) === this.positionOfCircle1) || (((rowIndex * 4) + (colIndex - 1)) === this.positionOfCircle2)) {
          for (let i = 0; i < this.brDisplayIndexXTable.length; i += 1) {
            this.$refs[this.brDisplayIndexXTable[i]][this.brDisplayIndexYTable[i]].style.cssText = 'background-color:#66BB6A !important;';
          }
          this.buttonPushed = true;
          this.sendAnswer(1);
        } else if ((((rowIndex * 4) + (colIndex - 1)) === this.positionOfStar1) || (((rowIndex * 4) + (colIndex - 1)) === this.positionOfStar2) || (((rowIndex * 4) + (colIndex - 1)) === this.positionOfStar3)) {
          this.showStars();
          this.buttonPushed = true;
          this.sendAnswer(0);
        }
      }
    },
    sendAnswer(value) {
      let isCorrectAnswer = false;
      this.$axios({
        url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${value}`,
        method: 'GET',
        headers: {
          Authorization: this.jwtInVuex,
        },
      }).then((response) => {
        const responseData = response.data.data;
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          if (responseData.status === 'WRONG_ANSWER') {
            isCorrectAnswer = false;
          } else if (responseData.status === 'CORRECT_ANSWER') {
            isCorrectAnswer = true;
          }
        }
        console.log('wait 1,5 secs for response and go to next game');
        setTimeout(() => {
          console.log('Go to next game');
          this.normalTransition = true;
          this.storeBrainiacGameData(isCorrectAnswer);
        }, 1500);
      }).catch((error) => {
        console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
      });
    },
    initStarsAndCircle() {
      const x = Math.floor((Math.random() * 2)); // ka8orizei pou 8a katanemi8oun ta starting points
      const p1 = Math.floor((Math.random() * 8));
      const p2 = Math.floor((Math.random() * 8));
      let numberOfStars = 0; // counter gia to poses bombs exoume
      if (x === 0) {
        this.positionOfCircle1 = this.matrixX1[p1]; // initializing positionOfCircle
        this.positionOfCircle2 = this.matrixX2[p2];
      } else {
        this.positionOfCircle1 = this.matrixY1[p1];
        this.positionOfCircle2 = this.matrixY2[p2];
        if (this.positionOfCircle2 - this.positionOfCircle1 === 1) { // orizontios geitonika, ta apomakrinw kai 8a valw bomb endiamesa
          this.positionOfCircle2 += 1;
        }
        if (this.positionOfCircle2 - this.positionOfCircle1 === 2 && this.positionOfCircle1 !== 6 && this.positionOfCircle1 !== 7) { // an exoun diafora 2 block orizontia vale endiamesa narkh
          this.positionOfStar1 = this.positionOfCircle1 + 1;
          numberOfStars = 1;
        }
      }
      if ((this.positionOfCircle2 - this.positionOfCircle1) >= 6) { // kapoia cases gia na vazw ta bombs ligo pio eksipna
        console.log('1');
        numberOfStars = 1;
        this.positionOfStar1 = this.positionOfCircle1 + 4;
      } else if ((this.positionOfCircle2 - this.positionOfCircle1) === 3 && x === 1) {
        console.log('9');
        numberOfStars = 2;
        this.positionOfStar1 = this.positionOfCircle1 + 1;
        this.positionOfStar2 = this.positionOfCircle2 - 1;
      } else if ((this.positionOfCircle1 - this.positionOfCircle2) === 3 && x === 1) {
        console.log('10');
        numberOfStars = 2;
        this.positionOfStar1 = this.positionOfCircle1 + 1;
        this.positionOfStar2 = this.positionOfCircle2 - 1;
      } else if ((this.positionOfCircle1 - this.positionOfCircle2) > 5) {
        console.log('2');
        numberOfStars = 1;
        this.positionOfStar1 = this.positionOfCircle2 + 4;
      } else if ((this.positionOfCircle1 - this.positionOfCircle2) <= 4 && (this.positionOfCircle1 - this.positionOfCircle2) > 0) {
        console.log('3');
        numberOfStars = 1;
        this.positionOfStar1 = this.positionOfCircle2 - 1;
      }
      if ((this.positionOfCircle2 - this.positionOfCircle1 === 3) && x === 1) {
        console.log('4');
        numberOfStars = 2;
        this.positionOfStar1 = this.positionOfCircle1 + 1;
        this.positionOfStar2 = this.positionOfCircle1 + 2; // se idia eu8ia me 2 block diafora
      } else if ((this.positionOfCircle2 - this.positionOfCircle1) <= 4 && x === 1 && (this.positionOfCircle2 - this.positionOfCircle1) > 1) {
        console.log('5');
        numberOfStars = 1;
        this.positionOfStar1 = this.positionOfCircle2 - 1;
      }
      if (this.positionOfCircle1 >= 4 && this.positionOfCircle2 - this.positionOfCircle1 === 4) { // ka8etos geitonika
        console.log('6');
        this.positionOfCircle2 += 1; // meta apo auth thn allagh ginontai diagwnies me apostash = 5
      }
      if (this.positionOfCircle1 > 4 && (this.positionOfCircle2 - this.positionOfCircle1 === 3) && x === 0) {
        console.log('7');
        numberOfStars = 2;
        this.positionOfStar1 = this.positionOfCircle1 - 1;
        this.positionOfStar2 = this.positionOfCircle2 + 1; // diagwnia me apostash 3
      }
      if (x === 0 && this.positionOfCircle2 - this.positionOfCircle1 === 5) { //   stis simetrika diagwnies vale vomves ektos apo thn periptwsh pou einai 7 to p1
        console.log('8');
        numberOfStars = 2;
        this.positionOfStar1 = this.positionOfCircle1 + 1;
        this.positionOfStar2 = this.positionOfCircle1 + 4;
      }

      if (this.positionOfStar1) { // afairw ta position twn star apo tous pinakes
        const star11 = this.oneQuarter.indexOf(this.positionOfStar1);
        const star12 = this.twoQuarter.indexOf(this.positionOfStar1);
        const star13 = this.threeQuarter.indexOf(this.positionOfStar1);
        const star14 = this.fourQuarter.indexOf(this.positionOfStar1);
        if (star11 > -1) { // only splice array when item is found
          this.oneQuarter.splice(star11, 1);
        }
        if (star12 > -1) { // only splice array when item is found
          this.twoQuarter.splice(star12, 1);
        }
        if (star13 > -1) { // only splice array when item is found
          this.threeQuarter.splice(star13, 1);
        }
        if (star14 > -1) { // only splice array when item is found
          this.fourQuarter.splice(star14, 1);
        }
        if (this.positionOfStar2) {
          const star21 = this.oneQuarter.indexOf(this.positionOfStar2);
          const star22 = this.twoQuarter.indexOf(this.positionOfStar2);
          const star23 = this.threeQuarter.indexOf(this.positionOfStar2);
          const star24 = this.fourQuarter.indexOf(this.positionOfStar2);
          if (star21 > -1) { // only splice array when item is found
            this.oneQuarter.splice(star21, 1);
          }
          if (star22 > -1) { // only splice array when item is found
            this.twoQuarter.splice(star22, 1);
          }
          if (star23 > -1) { // only splice array when item is found
            this.threeQuarter.splice(star23, 1);
          }
          if (star24 > -1) { // only splice array when item is found
            this.fourQuarter.splice(star24, 1);
          }
        }
      }
      let alternativePosition1;
      let alternativePosition2;
      let alternativePosition3;
      let alternativePosition4;
      if (x === 0) { // afairw ta position twn circle kai ftiaxnw alternative position gia ta stars
        const index1 = this.oneQuarter.indexOf(this.positionOfCircle1);
        const index2 = this.twoQuarter.indexOf(this.positionOfCircle1);
        const index3 = this.threeQuarter.indexOf(this.positionOfCircle2);
        const index4 = this.fourQuarter.indexOf(this.positionOfCircle2);
        if (index1 > -1) { // only splice array when item is found
          this.oneQuarter.splice(index1, 1);
          if (this.oneQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition1 = this.oneQuarter[number];
            this.oneQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.oneQuarter.length));
          alternativePosition3 = this.oneQuarter[number];
          this.oneQuarter.splice(number, 1);
        }
        if (index2 > -1) { // only splice array when item is found
          this.twoQuarter.splice(index2, 1);
          if (this.twoQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition1 = this.twoQuarter[number];
            this.twoQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.twoQuarter.length));
          alternativePosition3 = this.twoQuarter[number];
          this.twoQuarter.splice(number, 1);
        }
        if (index3 > -1) { // only splice array when item is found
          this.threeQuarter.splice(index3, 1);
          if (this.threeQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition2 = this.threeQuarter[number];
            this.threeQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.threeQuarter.length));
          alternativePosition4 = this.threeQuarter[number];
          this.threeQuarter.splice(number, 1);
        }
        if (index4 > -1) { // only splice array when item is found
          this.fourQuarter.splice(index4, 1);
          if (this.fourQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition2 = this.fourQuarter[number];
            this.fourQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.fourQuarter.length));
          alternativePosition4 = this.fourQuarter[number];
          this.fourQuarter.splice(number, 1);
        }
      } else {
        const index1 = this.oneQuarter.indexOf(this.positionOfCircle1);
        const index2 = this.twoQuarter.indexOf(this.positionOfCircle2);
        const index3 = this.threeQuarter.indexOf(this.positionOfCircle1);
        const index4 = this.fourQuarter.indexOf(this.positionOfCircle2);
        if (index1 > -1) { // only splice array when item is found
          this.oneQuarter.splice(index1, 1);
          if (this.oneQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition1 = this.oneQuarter[number];
            this.oneQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.oneQuarter.length));
          alternativePosition3 = this.oneQuarter[number];
          this.oneQuarter.splice(number, 1);
        }
        if (index2 > -1) { // only splice array when item is found
          this.twoQuarter.splice(index2, 1);
          if (this.twoQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition2 = this.twoQuarter[number];
            this.twoQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.twoQuarter.length));
          alternativePosition4 = this.twoQuarter[number];
          this.twoQuarter.splice(number, 1);
        }
        if (index3 > -1) { // only splice array when item is found
          this.threeQuarter.splice(index3, 1);
          if (this.threeQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition1 = this.threeQuarter[number];
            this.threeQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.threeQuarter.length));
          alternativePosition3 = this.threeQuarter[number];
          this.threeQuarter.splice(number, 1);
        }
        if (index4 > -1) { // only splice array when item is found
          this.fourQuarter.splice(index4, 1);
          if (this.fourQuarter.length > 2) {
            const number = Math.floor((Math.random() * 3));
            alternativePosition2 = this.fourQuarter[number];
            this.fourQuarter.splice(number, 1);
          }
        } else {
          const number = Math.floor((Math.random() * this.fourQuarter.length));
          alternativePosition4 = this.fourQuarter[number];
          this.fourQuarter.splice(number, 1);
        }
      }
      if (numberOfStars === 0) { // analoga ton initial ari8mo twn stars mpainei se case
        console.log('case1');
        this.positionOfStar1 = alternativePosition1;
        this.positionOfStar2 = alternativePosition2;
        this.positionOfStar3 = alternativePosition3;
      } else if (numberOfStars === 1) {
        console.log('case2');
        this.positionOfStar2 = !alternativePosition2 ? alternativePosition1 : alternativePosition2;
        this.positionOfStar3 = alternativePosition3;
      } else if (numberOfStars === 2) {
        console.log('case3');
        this.positionOfStar3 = alternativePosition3;
      }
      if (this.positionOfStar1 === 1 || this.positionOfStar2 === 1 || this.positionOfStar3 === 1) {
        if (this.positionOfStar1 === 6 || this.positionOfStar2 === 6 || this.positionOfStar3 === 6) {
          if (this.positionOfStar1 === 11 || this.positionOfStar2 === 11 || this.positionOfStar3 === 11) {
            this.positionOfStar3 = alternativePosition4;
          }
        }
      }
      if (this.positionOfStar1 === 2 || this.positionOfStar2 === 2 || this.positionOfStar3 === 2) {
        if (this.positionOfStar1 === 5 || this.positionOfStar2 === 5 || this.positionOfStar3 === 5) {
          if (this.positionOfStar1 === 8 || this.positionOfStar2 === 8 || this.positionOfStar3 === 8) {
            this.positionOfStar3 = alternativePosition4;
          }
        }
      }
      if (this.positionOfStar1 === 4 || this.positionOfStar2 === 4 || this.positionOfStar3 === 4) {
        if (this.positionOfStar1 === 9 || this.positionOfStar2 === 9 || this.positionOfStar3 === 9) {
          if (this.positionOfStar1 === 14 || this.positionOfStar2 === 14 || this.positionOfStar3 === 14) {
            this.positionOfStar3 = alternativePosition4;
          }
        }
      }
      if (this.positionOfStar1 === 7 || this.positionOfStar2 === 7 || this.positionOfStar3 === 7) {
        if (this.positionOfStar1 === 10 || this.positionOfStar2 === 10 || this.positionOfStar3 === 10) {
          if (this.positionOfStar1 === 13 || this.positionOfStar2 === 13 || this.positionOfStar3 === 13) {
            this.positionOfStar3 = alternativePosition4;
          }
        }
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryBombs.vue